export type NewChatScope = { companyID: string; projectID: string; periodID?: string }

export function resolveNewChatScope(
  selected: { entityId: string; projectId: string; periodId: string },
  activeChat?: { companyID?: string; projectID?: string; periodID?: string | null },
): NewChatScope | undefined {
  if (selected.entityId && selected.projectId)
    return { companyID: selected.entityId, projectID: selected.projectId, periodID: selected.periodId || undefined }
  if (activeChat?.companyID && activeChat.projectID)
    return { companyID: activeChat.companyID, projectID: activeChat.projectID, periodID: activeChat.periodID || undefined }
}

export function requestedNewChatScope(search: string, state: unknown) {
  const query = new URLSearchParams(search)
  const saved = isNewChatScope(state) ? state : undefined
  const projectID = query.get("project") || saved?.projectID
  const sameProject = saved?.projectID === projectID
  return {
    projectID,
    companyID: query.get("company") || (sameProject ? saved?.companyID : undefined),
    periodID: query.get("period") || (sameProject ? saved?.periodID : undefined),
  }
}

function isNewChatScope(value: unknown): value is NewChatScope {
  if (!value || typeof value !== "object") return false
  const scope = value as Partial<NewChatScope>
  return typeof scope.companyID === "string" && !!scope.companyID &&
    typeof scope.projectID === "string" && !!scope.projectID &&
    (scope.periodID === undefined || typeof scope.periodID === "string")
}
